export const INTERACTIVE_CLICK_TARGETS = 'button, a, form, label, input, [role="menu"]'

// Returns true when the click bubbled up from a nested interactive
// element (e.g. a <button> inside a clickable card), so the outer
// handler can opt out. Direct clicks on an interactive element that
// itself carries the Stimulus action are NOT considered nested — the
// listener's `currentTarget` is the interactive element, so the action
// is intended.
export function clickedInteractiveTarget (event) {
  const interactive = event.target.closest(INTERACTIVE_CLICK_TARGETS)
  if (!interactive) return false
  if (interactive === event.currentTarget) return false
  return true
}
